import api from '../../../utils/api';
import { ZohoCustomDeskTicketPath } from './enums';

export default class ZohoCustomDeskTicketService {
  static createDeskTicket(data) {
    return api.post(`${ZohoCustomDeskTicketPath.ZohoCustomDeskTicket}`, data);
  }
}
